export default "__VITE_ASSET__RxXanDHX__"